import { Instance, types } from 'mobx-state-tree';
import i18n from '../../app/i18n';
import { AVAILABLE_LANGUAGES } from 'src/app/settings';
import { logError } from 'src/_shared/logger';

export type I18nInstance = Instance<typeof I18n>;

export const I18n = types
  .model({})
  .volatile(() => ({
    t: i18n.t,
    exists: i18n.exists,
    language: i18n.language,
  }))
  .views(self => ({
    isLanguageAvailable(language: string): boolean {
      return AVAILABLE_LANGUAGES.includes(language);
    },
    isDictionaryKeyAvailable(key: string): boolean {
      return !!self.exists(key);
    },
  }))
  .actions(self => ({
    changeLanguage(language: string): void {
      if (self.isLanguageAvailable(language)) {
        i18n.changeLanguage(language);
        self.language = language;
      } else {
        logError(`[i18n] Language ${language} is not available`);
      }
    },
  }));
